import { Component, OnInit } from '@angular/core';
import { BnplService } from '../../shared/services/bnpl.service';
import { Payment } from '../../shared/models/payment.model';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { Router } from '@angular/router';
import { Client } from '../../shared/models/client.model';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
})
export class PaymentComponent implements OnInit {
  public payment: Payment;
  public datePaid: string = '';
  public clientInformation: Client;
  fileData: any;
  panelOpenState = false;
  faAngle = faAngleDown;
  partnerName: string = localStorage.getItem('partnerName') || '';
  printVoucher: boolean = false;

  constructor(
    private readonly bnplService: BnplService,
    private readonly router: Router
  ) {
    this.payment = this.bnplService.payment;
    this.clientInformation = this.bnplService.stepsInformation.thirdStep.client;
    const date = this.payment.datePaid.split('/').join('-');
    this.datePaid = this.formatDate(date);
  }

  formatDate(dateString: string): string {
    const date = parseISO(dateString);
    return format(date, 'dd MMMM yyyy', { locale: es });
  }

  ngOnInit(): void {
    const navbar = document.querySelector('.navbar-approbe') as HTMLElement;
    if (navbar !== null) {
      navbar.style.backgroundColor = '#3886FF';
    }

    const body = document.querySelector('body');
    if (body !== null) {
      body.style.backgroundColor = '#3886FF';
    }

    Swal.close();
  }

  print() {
    this.printVoucher = true;
    setTimeout(() => {
      this.printVoucher = false;
    }, 5000);
    // this.bnplService.alertWait(); // Muestra una alerta de espera
    // this.fileData = this.bnplService.dataTemplate.template;
    // const container = document.createElement('div');
    // container.innerHTML = this.fileData;
    // container.style.width = '800px'; // Ajusta el ancho para que se vea bien
    // container.style.padding = '20px';
    // document.body.appendChild(container);
    // // Convertir HTML a Canvas
    // html2canvas(container, { scale: 3 }).then((canvas) => {
    //   const imgData = canvas.toDataURL('image/png');
    //   const pdf = new jsPDF('p', 'mm', 'a4');
    //   const imgWidth = 190; // Ancho del PDF
    //   const pageHeight = 297; // Altura del PDF
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   let heightLeft = imgHeight;
    //   let position = 0;
    //   pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    //   heightLeft -= pageHeight;
    //   while (heightLeft > 0) {
    //     position -= pageHeight;
    //     pdf.addPage();
    //     pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    //     heightLeft -= pageHeight;
    //   }
    //   pdf.save('boucher.pdf');
    //   // Elimina el contenedor de manera segura
    //   setTimeout(() => document.body.removeChild(container), 0);
    //   Swal.close(); // Cierra la alerta
    // }).catch((error) => {
    //   console.error('Error al generar el PDF:', error);
    //   Swal.fire('Error', 'No se pudo generar el PDF', 'error');
    // });
  }

  finish() {
    localStorage.clear();
    window.location.href = this.bnplService.personalInformation.urlRedirect;
  }
}
